{
  "de": {
    "markdownEditor": {
      "toolbar": "Formatierung",
      "bold": "Fett",
      "italic": "Kursiv",
      "heading": "Überschrift",
      "bulletList": "Aufzählung",
      "orderedList": "Nummerierte Liste",
      "center": "Zentrieren",
      "details": "Einklappbarer Abschnitt",
      "detailsCollapse": "Abschnitt einklappen",
      "detailsExpand": "Abschnitt ausklappen",
      "link": "Link",
      "linkUrl": "Linkadresse",
      "linkUrlPlaceholder": "https://…",
      "linkApply": "Übernehmen",
      "linkRemove": "Link entfernen",
      "linkInvalid": "Verlinkt werden können nur http(s)-Adressen oder Pfade auf dieser Seite.",
      "image": "Bild",
      "imageAlt": "Beschreibung des Bildes",
      "imageApply": "Einfügen",
      "close": "Schließen",
      "source": "Markdown-Quelltext bearbeiten",
      "imageUploadFailed": "Das Bild konnte nicht hochgeladen werden. Bitte versuche es erneut.",
      "imageTitle": "Bild einfügen",
      "imageAltHint": "Wird anstelle des Bildes vorgelesen und angezeigt, falls es nicht geladen werden kann.",
      "cancel": "Abbrechen",
      "imageSize": "Bildgröße",
      "imageSize25": "Klein",
      "imageSize50": "Mittel",
      "imageSize75": "Groß",
      "imageSizeFull": "Volle Breite",
      "item": "Katalogeintrag",
      "itemSearchHint": "Gib den Namen eines Eintrags ein",
      "itemSearchEmpty": "Kein gelisteter Eintrag mit diesem Namen",
      "itemType": {
        "Component": "Komponente",
        "Equipment": "Ausrüstung",
        "Commodity": "Rohstoff",
        "Model": "Schiff",
        "Blueprint": "Bauplan",
        "GameMission": "Mission",
        "Location": "Ort",
        "FleetContract": "Auftrag",
        "FleetEvent": "Event",
        "User": "Benutzer"
      }
    }
  }
}
